import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {HttpService} from '../service/http.service';
import {GlobalConfig} from '../../global';
import {TranslateService} from '@ngx-translate/core';
import {SharedService} from '../service/shared.service';

@Component({
  selector: 'app-kazakhstan',
  templateUrl: './kazakhstan.component.html',
  styleUrls: ['./kazakhstan.component.css']
})
export class KazakhstanComponent implements OnInit {
  winnersList: any;
  leadershipList: any;
  newsList: any;
  noNews: boolean;
  noLeaderships: boolean;
  noWinners: boolean;
  kazId: any;
  imgLang: string;

  constructor(public router: Router, private http: HttpService, public translate: TranslateService) {
  }

  ngOnInit(): void {
    this.imgLang = this.translate.getDefaultLang();
    this.getCityList();
    this.getNewsKaz();
    this.getLeadershipsByKaz();
    this.getWinnersByKaz();
  }

  getCityList() {
    this.http.getCityListService().subscribe(data => {
      console.log(data);
    });
  }

  getLeadershipsByKaz() {
    this.http.getKazLeadership().subscribe((data: any) => {
      if (data.length === 0) {
        this.noLeaderships = true;
      } else {
        this.leadershipList = data;
      }
    });
  }

  getWinnersByKaz() {
    this.http.getKazWinners().subscribe((data: any) => {
      if (data.length === 0) {
        this.noWinners = true;
      } else {
        this.winnersList = data;
      }
    });
  }

  getNewsKaz() {
    this.http.getKazNews().subscribe((data) => {
      this.noNews = data.length === 0;
      this.newsList = data;
    });
  }

  // Redirect Methods

  redirect(item) {
    this.router.navigate(['/city', item]);
  }

  redirectGuideItem(item) {
    this.router.navigate(['/leadership', item.id]);

  }
  redirectToWinnersPage(item) {
    let winnerId = item.id;
    this.router.navigate(['/city/winners', winnerId]);
  }

  redirectNewsPage(item) {
    let newsId = item.id;
    this.router.navigate(['/news/city', newsId]);
  }
}
